import { render, staticRenderFns } from "./_adminMenu.vue?vue&type=template&id=a00d2600&scoped=true"
import script from "./_adminMenu.vue?vue&type=script&lang=js"
export * from "./_adminMenu.vue?vue&type=script&lang=js"
import style0 from "./_adminMenu.vue?vue&type=style&index=0&id=a00d2600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00d2600",
  null
  
)

export default component.exports